import { Component } from '@angular/core';

@Component({
  selector: 'app-contratos-cancelados',
  templateUrl: './cancelados.component.html',
  styleUrl: './cancelados.component.css'
})
export class ContratosCanceladosComponent {

}
